import _defineProperty from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { getUserId } from '@/utils/auth';
export var fmtReqParams = function fmtReqParams(searchFormData, searchReq) {
  var _iterator = _createForOfIteratorHelper(searchFormData),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _step.value,
        key = _step$value.key,
        value = _step$value.value,
        selectedArr = _step$value.selectedArr;
      if (key === 'date') {
        var _ref = value || [],
          _ref2 = _slicedToArray(_ref, 2),
          start = _ref2[0],
          end = _ref2[1];
        searchReq.param.start = start || null;
        searchReq.param.end = end || null;
      } else if (key === 'todoName') {
        searchReq.param[key] = value;
      } else {
        searchReq.param[key] = selectedArr;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return searchReq;
};
export var query = function query(status) {
  var _param;
  return {
    param: (_param = {
      start: null,
      end: null
    }, _defineProperty(_param, status, []), _defineProperty(_param, "systemId", null), _defineProperty(_param, "systemModule", null), _defineProperty(_param, "userId", getUserId()), _param),
    orderBy: null,
    pageNum: 1,
    pageSize: 10
  };
};